import { useMutation } from 'react-query';

import { axios } from 'lib/axios';
import { queryClient } from 'lib/react-query';

const deleteSubscriber = (id) => {
  return axios.delete(`/api/subscribers/${id}`);
};

export const useDeleteSubscriber = () => {
  return useMutation(deleteSubscriber, {
    onSuccess: () => {
      queryClient.invalidateQueries('subscribers');
    },
  });
};
